/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import { Box } from '@mui/material';
import { css } from '@emotion/react';
import { ReactComponent as WhatsappIcon } from '../../../assets/svg/whatsapp.svg';
import { useGetToken } from '../../../hooks/useGetToken';
import { getUrlWithToken } from '../../../utils/getMediaURLWithToken';
import { WabaChannelType } from '../../../typings/waba';
import WhatsappBadgeIcon from '../../../icons/icons-revamp/whatsapp';
import InstagramIcon from '../../../icons/InstagramIcon.png';

const WabaIntegrationIcon = ({
  wabaIntegrationLogo,
  wabaIntegrationName,
  size = 40,
  channelType,
}: {
  wabaIntegrationLogo: string;
  wabaIntegrationName: string;
  size?: number;
  channelType?: WabaChannelType;
}) => {
  const token = useGetToken() || '';
  const imgURL = getUrlWithToken(wabaIntegrationLogo, token);

  const [wabaLogoErr, setWabaLogoErr] = useState<boolean>(false);

  const showBadge = channelType === WabaChannelType.WHATSAPP || channelType === WabaChannelType.INSTAGRAM;

  return (
    <Box
      css={css`
        height: ${size}px;
        min-height: ${size}px;
        max-height: ${size}px;
        width: ${size}px;
        min-width: ${size}px;
        max-width: ${size}px;
        flex: 0 0 auto;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: flex-start;
      `}
    >
      {imgURL && !wabaLogoErr ? (
        <img
          css={css`
            height: 100%;
            width: 100%;
            border-radius: 50%;
            object-fit: cover;
            object-position: center;
          `}
          src={imgURL}
          alt={wabaIntegrationName}
          loading="lazy"
          onError={() => setWabaLogoErr(true)}
        />
      ) : (
        <Box
          css={css`
            height: 100%;
            width: 100%;
            border: 1px solid #e0e0ea;
            display: flex;
            justify-content: center;
            align-items: center;
            align-self: center;
            border-radius: 999px;
            background-color: #1717171f;
          `}
        >
          <WhatsappIcon />
        </Box>
      )}
      {showBadge && (
        <Box
          css={css`
            position: absolute;
            bottom: 0;
            right: 0;
            transform: translate(30%, 30%);
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: white;
            border-radius: 50%;
            height: 18px;
            width: 18px;
          `}
        >
          {channelType === WabaChannelType.INSTAGRAM ? (
            <img
              src={InstagramIcon}
              alt="Instagram"
              css={css`
                width: 12px;
                height: 12px;
                object-fit: contain;
              `}
            />
          ) : (
            <WhatsappBadgeIcon size={12} color="#25D366" />
          )}
        </Box>
      )}
    </Box>
  );
};

export default WabaIntegrationIcon;
